import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { TotalSpentGreaterThanState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/total-spent_greater_than";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TotalSpentGreaterThanDetails = memo(
  function TotalSpentGreaterThanDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<TotalSpentGreaterThanState>) {
    return (
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Minimum order total
        </Text>
        <RedoTextInput
          IconLeading={() => <>$</>}
          inputTypeHint="number"
          min={0}
          placeholder="0.00"
          setValue={setState}
          state={disabled ? "readonly" : "default"}
          value={state}
        />
      </Flex>
    );
  },
);
